module.exports = __webpack_public_path__ + "media/images/download-4c6fdb1f.svg";